var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"locatorDiv",staticClass:"svg-container",attrs:{"id":_vm.svgContainerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }